<template>
    <svg :class="lsIconClass" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.41 9.41">
        <polygon
            fill="#b2b5bb"
            points="0.71 9.41 0 8.71 4 4.71 0 0.71 0.71 0 5.41 4.71 0.71 9.41"
        ></polygon>
    </svg>
</template>

<script>
export default {
    props: {
        lsIconClass: { type: String },
    },
};
</script>

<style lang="scss"></style>
